<template>
  <el-container class="container estado-de-cuenta" id="estado-de-cuenta">
    <el-col
      :xs="24"
      :sm="20"
      :md="22"
      :lg="20"
      :xl="20"
    >
      <el-row
        class="hide-on-print header-actions" type="flex"
        justify="center"
      >
        <el-button @click="$goBack()">
          Volver
        </el-button>
        <router-link to="/busqueda-del-predio" style="margin: 0px 10px">
          <el-button>
            Consultar otra cuenta
          </el-button>
        </router-link>
      </el-row>
      <el-col :span="24" class="frame-container">
        <iframe
          name=""
          class="doc"
          :src="documentoPDF"
          frameborder="0"
        />
      </el-col>
    </el-col>
  </el-container>
</template>

<script>
import qrcode from 'qrcode-generator';
import JsBarcode from 'jsbarcode';

import Moment from 'moment';
import { DOMImplementation, XMLSerializer } from 'xmldom';
import { mapState } from 'vuex';
import pdfAccountWithQR from '../utils/account-status-qr-pdf/index';
import generate from '../utils/generateRef';

export default {
  data() {
    return {
      references: [],
      codes: [],
      documentoPDF: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.predio.user,
      data: (state) => state.predio.data,
    }),
    /**
     * Filtra los datos provenientes del Web Service
     * y regresa solo la información de impuestos
     * de predio.
     * @readonly
     * @returns Array<Object>
     */
    debtsData() {
      // Expresión regular para buscar la palabra 'impuesto' en mayúscula y minúscula
      // const regExp = new RegExp('impuesto', 'i');
      const regExp = /(impuesto|gastos|predial|notificacion)/i;
      /**
       * Filtra los datos del web service aplicando la expresión
       * regular en el campo de 'observaciones'
       */
      const output = this.data.filter((x) => regExp.test(x.observaciones));
      // Objeto de fecha
      const currentDate = new Moment();
      // Obtenemos el año actual en valor numérico
      const currentYear = parseInt(currentDate.format('YYYY'), 10);

      // Obtenemos el mes actual en valor numérico
      const currentMonth = parseInt(currentDate.format('MM'), 10);

      // Obtenemos el día actual en valor numérico
      const currentDay = parseInt(currentDate.format('DD'), 10);

      /**
       * Busca la información de adeudos de predio que ya han vendido
       * relativo a la fecha actual y modifica cada elemento en la
       * colección de ser necesario.
       */
      const arrayFields = output.map((x) => {
        // Buscamos el año con una expresión regular en el campo 'observaciones'.
        // let yearMatch = /predial ([0-9]{0,4})/i.exec(x.observaciones)[1];
        let yearMatch = /predial ([0-9]{0,4})|predial|gastos|notificacion/i.exec(x.observaciones)[1];
        /**
         * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
         * convertir el valor de texto a valor numérico.
         */
        yearMatch = typeof yearMatch === 'string' ? parseInt(yearMatch, 10) : null;

        // Buscamos el número del bimestre con una expresión regular en el campo 'observaciones'.
        // let numMatch = /(bim.|bimestre) ([0-9]{0,2})/i.exec(x.observaciones)[2];
        let numMatch = /(((bim.|bimestre) ([0-9]{0,2}))|predial|gastos|notificacion)/i.exec(x.observaciones)[2];
        /**
         * Revisamos que la búsqueda nos haya retornado un valor para en caso de ser cierto
         * convertir el valor de texto a valor numérico.
         */
        numMatch = typeof numMatch === 'string' ? parseInt(numMatch, 10) : null;

        /**
         * Verifica si el año y bimestre ya vencieron.
         * De ser cierto, coloca la bandera 'disabled' en 'true',
         * para que los datos no pueden ser deseleccionados de la tabla.
         */
        const months = (numMatch * 2) - 1;

        const disabled = (yearMatch && yearMatch < currentYear)
        || (yearMatch && yearMatch >= currentYear && currentMonth > months)
        || (yearMatch && yearMatch === currentYear && currentMonth <= months)
        || (!yearMatch)
        || (yearMatch && yearMatch >= currentYear && numMatch
        && (currentMonth >= months && currentDay > 15));
        // Retorna el elemento o información de predio con las banderas preparadas.
        return {
          ...x,
          disabled,
          currentYear: yearMatch && yearMatch === currentYear,
          checked: typeof x.checked === 'boolean' ? x.checked : true,
        };
      });
      return arrayFields;
    },
    debts() {
      // const regExp = /impuesto/i;
      const regExp = /(impuesto|gastos|notificacion)/i;
      return this.debtsData.filter((x) => regExp.test(x.observaciones) && x.checked);
    },
    /**
     * Calcula y retorna el total de importe base
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    debtsTotalBase() {
      const sum = this.debts.reduce((prev, curr) => prev + (curr.importe_base * 1000), 0);
      // let sum = this.debts.reduce((prev, curr) => prev + (curr.importe_base * 1000), 0);
      // sum += this.surchargeTotal + this.finesTotal + this.notificationTotal + this.actTotal;
      // sum -= this.specialDiscountTotal + this.discountEarlyPay;
      // return sum;
      return sum / 1000 || 0;
    },
    allChecked() {
      // const regExp = /impuesto/i;
      const regExp = /(impuesto|gastos|notificacion)/i;
      // const regExp = /(impuesto|notificacion)/i;
      return this.data.filter((x) => regExp.test(x.observaciones)).every((x) => x.checked);
    },
    /**
     * Calcula y retorna el total de actualización
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    actTotal() {
      const sum = this.debts.reduce((prev, curr) => prev + (curr.actualizacion * 1000), 0);
      return sum / 1000 || 0;
    },
    allExpiredChecked() {
      // return this.debts.some((e) => !e.disabled);
      return true;
    },
    /**
     * Calcula y retorna el total de recargo
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    surchargeTotal() {
      const sum = this.debts.map((e) => this.singleSurchargeTotal(e))
        .reduce((prev, curr) => prev + (curr * 1000), 0);

      return sum / 1000 || 0;
    },
    /**
     * Calcula y retorna el total de notificación
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    notificationTotal() {
      const sum = this.debts.reduce((prev, curr) => prev + (curr.gasto * 1000), 0);
      return sum / 1000 || 0;
    },
    /**
     * Calcula y retorna el total de multas
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    finesTotal() {
      const sum = this.debts.map((e) => this.singleFineTotal(e))
        .reduce((prev, curr) => prev + (curr * 1000), 0);

      return sum / 1000 || 0;
    },
    /**
     * Calcula y retorna el total de descuentos
     * por pronto pago en base a la
     * información de impuestos.
     * @readonly
     * @returns {Number}
     */
    discountEarlyPay() {
      const sum = this.debts
        .reduce((prev, curr) => prev + (curr.descuentoAplicableCargo * 1000), 0);
      /*
        if (!this.allChecked) {
        if (curr.descuentTerceraEdad > 0){
          return curr.descuentTerceraEdad;
        }else {
          return 0;
        }
      }
      */
      return sum / 1000 || 0;
    },
    /**
     * Calcula y retorna el total de descuento especial
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    specialDiscountTotal() {
      const sum = this.debts.reduce((prev, curr) => prev + ((curr.descuentoRecargoAplicable
       + curr.descuentoMultaAplicable) * 1000), 0);
      // console.log("specialDiscountTotal sum "+sum);
      return sum / 1000 || 0;
    },
    /**
     * Calcula y retorna el total de adeudo
     * en base a la información de impuestos.
     * @readonly
     * @returns {Number}
     */
    debtsTotal() {
      let sum = this.debtsTotalBase;
      sum += this.surchargeTotal + this.finesTotal + this.notificationTotal + this.actTotal;
      sum -= this.specialDiscountTotal + this.discountEarlyPay;
      return sum;
    },
    /**
     * Retorna el total de adeudo redondeado
     * @readonly
     * @returns {Number}
     */
    debtsTotalRounded() {
      return Math.round(this.debtsTotal);
    },
    /**
     * Retorna los centavos perdidos o ganados del
     * redondeo del total de adeudo
     * @readonly
     * @returns {Number}
     */
    debtsTotalExtra() {
      return this.debtsTotalRounded - this.debtsTotal;
    },
    /**
     * Calcula y retorna el total de servicios de salud
     * @readonly
     * @returns {Number}
     */
    healthServicesTotal() {
      // const items = this.data.filter((x) => /servicios de salud/i.test(x.observaciones));
      // const sum = items.reduce((prev, curr) => prev + (curr.adeudo * 1000), 0);
      const sum = 30;
      // return sum / 1000 || 0;
      return sum;
    },
    /**
     * Calcula y retorna el total de seguro casa habitacional
     * @readonly
     * @returns {Number}
     */
    houseInsuranceTotal() {
      const items = this.data.filter((x) => /seguro casa/i.test(x.observaciones));
      const sum = items.reduce((prev, curr) => prev + (curr.adeudo * 1000), 0);

      return sum / 1000 || 0;
    },
    /**
     * Retorna la suma de los totales involucrados
     * @readonly
     * @returns {Number}
     */
    total() {
      return this.debtsTotalRounded + this.healthServicesTotal + this.houseInsuranceTotal;
    },
    /**
     * Retorna la suma de los totales involucrados
     * sin contar servicios de salud
     * @readonly
     * @returns {Number}
     */
    totalWithOutHealthServices() {
      return this.debtsTotalRounded + this.houseInsuranceTotal;
    },
    /**
     * Retorna la suma de los totales involucrados
     * sin contar seguro casa habitacional
     * @readonly
     * @returns {Number}
     */
    totalWithOutHouseInsurance() {
      return this.debtsTotalRounded + this.healthServicesTotal;
    },
    /**
     * Busca y retorna el primer periodo
     * @readonly
     * @returns {Object}
     */
    firstPeriod() {
      const [item] = this.debts;
      const yearRegExp = /predial ([0-9]{4})|gastos|notificacion/i;
      const yearMatch = yearRegExp.exec(item.observaciones);
      const year = Array.isArray(yearMatch) ? yearMatch[1] : 'N/A';
      // const numRegExp = /(bim.|bimestre) ([0-9]{1})/i;
      const numRegExp = /(((bim.|bimestre) ([0-9]{0,2})))|gastos|notificacion/i;
      const numMatch = numRegExp.exec(item.observaciones);
      const num = Array.isArray(numMatch) ? numMatch[2] : 'N/A';
      return {
        year,
        num,
      };
    },
    /**
     * Busca y retorna el último periodo
     * @readonly
     * @returns {Object}
     */
    lastPeriod() {
      const item = this.debts[this.debts.length - 1];
      const yearRegExp = /predial ([0-9]{4})|gastos|notificacion/i;
      const yearMatch = yearRegExp.exec(item.observaciones);
      const year = Array.isArray(yearMatch) ? yearMatch[1] : 'N/A';
      // const numRegExp = /(bim.|bimestre) ([0-9]{1})/i;
      const numRegExp = /(((bim.|bimestre) ([0-9]{0,2})))/i;
      const numMatch = numRegExp.exec(item.observaciones);
      const num = Array.isArray(numMatch) ? numMatch[2] : 'N/A';
      return {
        year,
        num,
      };
    },
    /**
     * Busca y retorna los periodos
     * del último año
     * @readonly
     * @returns Array<Object>
     */
    lastYear() {
      const item = this.debts[this.debts.length - 1];
      const yearRegExp = /predial ([0-9]{4})|gastos|notificacion/i;
      const yearMatch = yearRegExp.exec(item.observaciones);
      if (yearMatch && yearMatch > 0) {
        const regexFilter = new RegExp(yearMatch[1], 'i');
        const lastYear = this.debts.filter((a) => regexFilter.test(a.observaciones));
        return lastYear;
      }
      return 0;
    },
    /**
     * Nos indica si el método de pago por OXXO aplica a
     * la cantidad total.
     * @readonly
     * @returns {Boolean}
     */
    OXXOPayIsAvailable() {
      return this.total <= 10000;
    },
    /**
     * Nos indica si el método de pago por banco aplica a
     * la cantidad total.
     * @readonly
     * @returns {Boolean}
     */
    bankPaymentIsAvailable() {
      return this.total <= 999999;
    },
  },
  methods: {
    singleFineTotal(scope) {
      const output = scope.multa;
      // let output = scope.multa - scope.descuentoMulta;
      /*
      if (scope.currentYear) {
        if (!this.allChecked) {
          output += scope.descuentoMultaAplicable;
        }
      } else if (!this.allExpiredChecked) {
        output += scope.descuentoMultaAplicable;
      }
      */
      return output;
    },
    singleSurchargeTotal(scope) {
      // let output = scope.recargo - scope.descuentoRecargo;
      const output = scope.recargo;
      /*
      if (scope.currentYear) {
        if (!this.allChecked) {
          output += scope.descuentoRecargoAplicable;
        }
      } else if (!this.allExpiredChecked) {
        output += scope.descuentoRecargoAplicable;
      }
      */
      return output;
    },
    /**
     * Abre la ventana de impresión en PDF del navegador.
     */
    async print() {
      const doc = await pdfAccountWithQR({
        predio: this.user,
        totals: {
          debtsTotalBase: this.debtsTotalBase,
          actTotal: this.actTotal,
          surchargeTotal: this.surchargeTotal,
          notificationTotal: this.notificationTotal,
          finesTotal: this.finesTotal,
          discountEarlyPay: this.discountEarlyPay,
          discountTotal: this.discountTotal,
          specialDiscountTotal: this.specialDiscountTotal,
          debtsTotal: this.debtsTotal,
          debtsTotalRounded: this.debtsTotalRounded,
          debtsTotalExtra: this.debtsTotalExtra,
          healthServicesTotal: this.healthServicesTotal,
          houseInsuranceTotal: this.houseInsuranceTotal,
          total: this.total,
          totalWithOutHealthServices: this.totalWithOutHealthServices,
          totalWithOutHouseInsurance: this.totalWithOutHouseInsurance,
          firstPeriod: this.firstPeriod,
          lastPeriod: this.lastPeriod,
          lastYear: this.lastYear,
          OXXOPayIsAvailable: this.OXXOPayIsAvailable,
          bankPaymentIsAvailable: this.bankPaymentIsAvailable,
        },
        houseInsurance: this.houseInsuranceTotal !== 0,
        dateForLink: this.getDateForLink(),
      });
      this.documentoPDF = doc.output('datauristring');
      const string = doc.output('datauristring');
      const iframe = `<iframe width='100%' height='100%' src='${string}'></iframe>`;
      const x = window.open();
      x.document.open();
      x.document.write(iframe);
      x.document.close();
      // window.open(doc.output('datauristring'));
    },
    /**
     * Retorna la fecha actual en formato DD/MM/YYYY.
     * @readonly
     * @returns {String}
     */
    getCurrentDate() {
      return new Moment().format('DD/MM/YYYY');
    },
    getDateForLink() {
      const today = new Moment();
      // const year = new Moment().format('YYYY');
      const maxDate = new Moment('DD/MM/YYYY');

      if (today.isSameOrBefore(maxDate)) {
        return maxDate.format('DD/MM/YYYY');
      }
      return today.format('DD/MM/YYYY');
    },
    /**
     * Genera referencias bancarias.
     */
    generateRefs() {
      const date = new Moment().format('DD/MM/YYYY');
      const ref = this.user.cuentadepredial;
      const amounts = [
        this.total,
        this.totalWithOutHealthServices,
        this.totalWithOutHouseInsurance,
        this.debtsTotalRounded,
      ];
      for (let idx = 0; idx < 4; idx++) {
        const {
          LINEA_BANCOS,
          LINEA_OXXO,
        } = generate(date, amounts[idx], ref);
        this.codes.push(LINEA_OXXO);
        this.references.push(LINEA_BANCOS);
      }
    },
    /**
     * Genera códigos de barras.
     */
    generateBarCode(code, id) {
      const xmlSerializer = new XMLSerializer();
      const doc = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
      const svgNode = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');

      JsBarcode(svgNode, code, {
        xmlDocument: doc,
        height: 72,
      });

      let svgText = xmlSerializer.serializeToString(svgNode);
      svgText = svgText.replace('transform: translate(0,0)', 'transform: translate(0,-30%) scale(.5);');
      svgText = svgText.replace('<text style="font: 20px monospace"',
        '<text style="font: 22px monospace; font-weight: bold"');
      const container = document.getElementById(id);
      if (container) {
        container.innerHTML = svgText;
      }
    },
    /**
     * Genera QRs.
     */
    async generateQR(id) {
      const qr = qrcode(0, 'L');
      let total = 0;
      switch (id) {
        case 'qr1':
          total = this.total;
          break;
        case 'qr2':
          total = this.totalWithOutHealthServices;
          break;
        case 'qr3':
          total = this.totalWithOutHouseInsurance;
          break;
        case 'qr4':
          total = this.debtsTotalRounded;
          break;
        default:
          break;
      }
      const { pk } = this.user;
      const baseURL = 'http://pagos.zapopan.gob.mx/PortalCiudadano/Recaudacion/RecaudoPredialQR.aspx?';
      // const baseURL = 'https://pruebasigob.zapopan.gob.mx/PortalCiudadanoPagoPruebas/Recaudacion/RecaudoPredialQR.aspx?';
      const URI = `${baseURL}OidPredio=${pk}&Importe=${total}&FechaPago=${this.getDateForLink()}`;
      qr.addData(URI);
      qr.make();
      let image = await qr.createImgTag();
      image = `${image.slice(0, 4)} class="qr-img"${image.slice(4 + Math.abs(0))}`;
      let img = `<a href="${URI}">${image}</a>`;
      img = img.replace(/(width\s*=\s*["'](.*?)["'])/g, 'width="120"');
      img = img.replace(/(height\s*=\s*["'](.*?)["'])/g, 'height="120"');
      const container = document.getElementById(id);
      if (container) {
        container.innerHTML = img;
      }
    },
  },
  /**
  * Formateo de datos, generación de referencias bancarias,
  * códigos QR y códigos de barras.
  */
  mounted() {
    this.generateRefs();
    for (let idx = 0; idx < 4; idx++) {
      this.generateQR(`qr${idx + 1}`);
    }
    this.codes.forEach((code, idx) => {
      if (code) {
        this.generateBarCode(code, `barCode${idx + 1}`);
      }
    });
  },
  async created() {
    if (!this.OXXOPayIsAvailable) {
      if (!this.bankPaymentIsAvailable) {
        this.$msgbox({
          type: 'warning',
          title: 'Aviso',
          message: `Las cantidades sobrepasan los límites posibles a pagar.
                Favor de pasar a una recaudadora a realizar su pago.`,
          showButtonCancel: false,
          center: true,
        });
      } else {
        this.$msgbox({
          type: 'warning',
          title: 'Aviso',
          message: `Las cantidades sobrepasan los límites posibles a pagar en OXXO (Código de barras).
                Usted puede utilizar la referencia bancaria, el código QR o pasar a una recaudadora a realizar su pago`,
          showButtonCancel: false,
          center: true,
        });
      }
    }
    const doc = await pdfAccountWithQR({
      predio: this.user,
      totals: {
        debtsTotalBase: this.debtsTotalBase,
        actTotal: this.actTotal,
        surchargeTotal: this.surchargeTotal,
        notificationTotal: this.notificationTotal,
        finesTotal: this.finesTotal,
        discountEarlyPay: this.discountEarlyPay,
        discountTotal: this.discountTotal,
        specialDiscountTotal: this.specialDiscountTotal,
        debtsTotal: this.debtsTotal,
        debtsTotalRounded: this.debtsTotalRounded,
        debtsTotalExtra: this.debtsTotalExtra,
        healthServicesTotal: this.healthServicesTotal,
        houseInsuranceTotal: this.houseInsuranceTotal,
        total: this.total,
        totalWithOutHealthServices: this.totalWithOutHealthServices,
        totalWithOutHouseInsurance: this.totalWithOutHouseInsurance,
        firstPeriod: this.firstPeriod,
        lastPeriod: this.lastPeriod,
        lastYear: this.lastYear,
        OXXOPayIsAvailable: this.OXXOPayIsAvailable,
        bankPaymentIsAvailable: this.bankPaymentIsAvailable,
      },
      houseInsurance: this.houseInsuranceTotal !== 0,
      dateForLink: this.getDateForLink(),
    });
    const base64 = doc.output('datauristring');
    this.documentoPDF = base64;
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-size: 12px;
  justify-content: center;
  padding: 0;
  overflow-x: hidden;
  * {
    font-family: Arial;
  }
  text {
    font-weight: bold !important;
  }
  .general {
    p {
      margin: 5px 0;
    }
    b {
      font-size: 10px;
    }
  }
  .badge-title {
    color: White;
    background-color: #B9A5CB;
    font-weight: bold;
    font-size: 16px;
    border-radius: 15px;
    text-align: center;
    padding: 3px;
    margin: 5px 0;
    width: 100%;
    a.link {
      text-decoration: none;
      color: #FFFFFF;
    }
  }
  .dark, .light {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .dark {
    font-size: 9px;
    background-color: #856BAD;
    justify-content: space-between;
    font-weight: 500;
  }
  .light {
    font-size: 12px;
    background-color: #C6A6DF;
    font-weight: bold;
    justify-content: space-around;
  }
  .el-button {
    background-color: #956FA8;
    color: #FFFFFF;
  }
  .thanks {
    width: 50%;
  }
  .top-banner {
    width: 100%;
  }
  .content {
    font-size: 9px;
    padding: 1px;
    font-weight: bold;
  }
  .caption {
    color: #330066;
    font-family: Arial;
    font-size: 8pt;
    font-weight: bold;
    text-align: justify;
  }
  .info {
    color: #330066;
    font-family: Arial;
    font-size: 8pt;
    text-align: justify;
  }
  .adeudos {
    position: relative;
    .el-row .el-col {
      font-family: Arial;
      font-size: 8pt;
    }
    .el-row .el-col:nth-child(1) {
      p {
        font-weight: bold;
      }
    }
    .el-row .el-col:nth-child(2) {
      p {
        text-align: end;
        // width: 50px;
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 5%;
      width: 90%;
      height: 5px;
      background-color: #C3A4CC;
    }
  }
  .page-braker {
    height: 300px;
  }
  .payments {
    .payment {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      padding-right: 10px;
      &:nth-child(1):after, &:nth-child(3):after {
        content: '';
        background-color: #B289FA;
        position: absolute;
        right: -15px;
        width: 1px;
        top: 35%;
        bottom: 35%;
      }
      .adeudo {
        width: 100%;
        p:last-of-type {
          text-align: center;
        }
        .el-col:nth-child(2) {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 26px;
          margin-bottom: 10px;
        }
        center {
          height: 70px;
        }
      }
    }
    .qr {
      padding: 10px 20px 20px 20px;
    }
    #barCode1, #barCode2, #barCode3, #barCode4 {
      height: 80px;
    }
  }
  .banner {
    margin-top: 15px;
    img {
      width: 100%;
    }
  }
}
.frame-container {
  margin-top: 20px;
  .doc {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 180px);
  }
}
@media only screen and (max-width: 767px) {
  .payments {
    flex-direction: row !important;
    .payment:nth-child(1):after,
    .payment:nth-child(3):after {
      content: '';
      position: absolute;
      width: 0 !important;
    }
  }
}
@media only screen and (max-width: 520px) {
  .header-actions {
    flex-direction: column !important;
    a, button {
      width: 100%;
      margin: 2.5px 0px !important;
    }
  }
  .payments {
    display: flex;
    flex-direction: column !important;
    width: 100%;
    .payment {
      width: 100%;
    }
  }
  .bank {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin: 5px 0;
    }
  }
  .dark {
    flex-direction: column !important;
  }
  .banner {
    margin-top: 15px;
    img {
      width: 100%;
      margin-bottom: 100px;
    }
  }
  .page-break {
    height: 350px;
  }
}
</style>

<style lang="scss">
@media print {
  .hide-on-print, .header {
    display: none;
  }
  .adeudos {
    .el-row {
      .el-col.el-col-offset-1 {
        max-width: 120px;
      }
    }
  }
  .page-break {
    page-break-before: always;
  }
  .payments {
    padding-top: 25px;
    flex-direction: row !important;
    .payment {
      width: 45% !important;
    }
  }
  .el-main {
    padding: 0px;
  }
}

</style>
